const allExt = ['gif', 'jpeg', 'jpg', 'png', 'webp', 'zip', 'pdf', 'xls', 'xlsx', 'doc', 'docx', 'xmind', 'xml', 'apk', 'css', 'html', 'js', 'json', 'md', 'mp4', 'mp3', 'ppt', 'pptx', 'psd', 'rar', 'txt', 'wps', 'ai', 'bak', 'c', 'docm', 'exe', 'htm', 'map'];

export function getExt (url) {
  const ext = url.substring(url.lastIndexOf(".") + 1, url.length);
  if (allExt.includes(ext)) {
    return ext;
  } else {
    return 'unknown'
  }
}

export function isImg (url) {
  let reg = new RegExp(/(png|jpe?g|gif|svg|webp|bmp|tpg|heif|avif|pic)(\?.*)?$/);
  return reg.test(url.substring(url.lastIndexOf(".") + 1, url.length));
}

